import React from 'react';
import {
  Text,
  DetailsList,
  SelectionMode,
  DetailsListLayoutMode,
  IDetailsListProps,
  DetailsRow,
  IColumn,
  useTheme,
} from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import { IPeriodos } from './PlanillaDigitalView';

interface IPlanillaDigitalGoalsDetailList {
  goalsList: any[]; // todocambiar a interface
  currentPeriod: IPeriodos;
  color: string;
}

const PlanillaDigitalGoalsDetailList = ({
  goalsList: oficialesList,
  currentPeriod,
  color,
}: IPlanillaDigitalGoalsDetailList) => {
  const goalsColumns: IColumn[] = React.useMemo(() => {
    const ret = [
      {
        key: 'PT',
        fieldName: 'pt',
        name: 'PT',
        minWidth: 50,
        maxWidth: 150,
      },
      {
        key: 'ST',
        fieldName: 'st',
        name: 'ST',
        minWidth: 50,
        maxWidth: 150,
      },

      {
        key: 'PTE',
        fieldName: 'pte',
        name: 'PTE',
        minWidth: 50,
        maxWidth: 150,
      },
      {
        key: 'STE',
        fieldName: 'ste',
        name: 'STE',
        minWidth: 50,
        maxWidth: 150,
      },
      {
        key: 'P',
        fieldName: 'p',
        name: 'P',
        minWidth: 50,
        maxWidth: 150,
      },
    ];
    return ret;
  }, [currentPeriod]);

  const getKey = (item: any, index?: number) => {
    return item.key;
  };

  const theme = useTheme();
  const _onRenderGolesRow: IDetailsListProps['onRenderRow'] = (props) => {
    if (props) {
      return (
        <div>
          <DetailsRow
            {...props}
            styles={{
              root: {
                backgroundColor: props.itemIndex % 2 === 0 ? theme.palette.neutralLight : 'transparent',
                selectors: {
                  ':hover': { backgroundColor: theme.palette.neutralQuaternaryAlt },
                },
              },
            }}
            className="planilla-detail-list"
          />
        </div>
      );
    }
    return null;
  };

  return (
    // <div style={{ border: '1px solid ' + color }}>
    <div>
      <DetailsList
        styles={{
          headerWrapper: { borderBottom: `3px solid ${color} !important` },
          root: { fontSize: '13px', fontWeight: 500 },
        }}
        items={oficialesList}
        selectionMode={SelectionMode.none}
        columns={goalsColumns}
        setKey="none"
        // layoutMode={DetailsListLayoutMode.}
        isHeaderVisible={true}
        getKey={getKey}
        onRenderRow={_onRenderGolesRow}
        onShouldVirtualize={() => false}
      />
    </div>
  );
};

export default PlanillaDigitalGoalsDetailList;
